import { connect } from 'react-redux';
import { PlansSelector } from '../reducers/PlansReducer';
import SwitchedToOpenTerm from '../../components/payment/SwitchedToOpenTerm/SwitchedToOpenTerm';

const mapStateToProps = state => ({
  hasSwitchedToOpenTerm: PlansSelector.getHasSwitchedToOpenTerm(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state)
});

const SwitchedToOpenTermContainer = connect(mapStateToProps)(SwitchedToOpenTerm);

export default SwitchedToOpenTermContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/SwitchedToOpenTermContainer.js
 **/